export type TextareaPart = {
  default: string;
  hover: string;
  focus: string;
  disabled: string;
};

export const textareaState = {
  bg: {
    default: 'bg-white/[0.05]',
    hover: 'peer-hover/field:bg-white/[0.08]',
    focus: 'peer-focus-visible/field:bg-white/[0.08]',
    disabled:
      'bg-gradient-to-b group-disabled/input:from-white/20 group-disabled/input:to-white/10',
  },
  border: {
    default: 'bg-gradient-to-b from-white/30 to-white/10',
    hover: '',
    focus:
      'peer-focus-visible/field:from-white peer-focus-visible/field:to-white',
    disabled: '',
  },
};
